import { AxiosError } from 'axios'
import HttpStatuses from 'http-status-codes'

import { BadRequestError, ForbiddenError, NotFoundError, UnauthorizedError, UnexpectedError } from 'modules/errors'

export const handleApiErrors = (error: AxiosError) => {
  const status = error.response?.status

  if (status && status >= 400 && status < 500) {
    switch (status) {
      case HttpStatuses.NOT_FOUND:
        throw new NotFoundError(error)

      case HttpStatuses.BAD_REQUEST:
        throw new BadRequestError(error)

      case HttpStatuses.UNAUTHORIZED:
        throw new UnauthorizedError(error)

      case HttpStatuses.FORBIDDEN:
        throw new ForbiddenError(error)

      default:
        throw new UnexpectedError(error)
    }
  }

  throw error
}
